import { render } from "./CheckboxButton.vue?vue&type=template&id=520a8a75"
import script from "./CheckboxButton.vue?vue&type=script&lang=js"
export * from "./CheckboxButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__